/* eslint-disable */
/**
 * Create styles for `<docketsPage />`
 * @param {Styles} styles The result of `createStyles`
 * @returns The `<docketsPage />` styles
 */
const docketsPageStyles = ({ theme }) => ({
  paper: {},
  root: {},
  sidebarRoot: {},
});

export default docketsPageStyles;
